import styles from './TabBarV2.module.css';

export default function TabBarV2({ activeTab, onTabChange }) {
    return (
        <div className={styles['tab-bar-v2']}>
            <button
                className={`${styles['tab-button-v2']} ${activeTab === 'cakes' ? styles['active'] : ''}`}
                onClick={() => onTabChange('cakes')}
            >
                Pasteles
            </button>
            <button
                className={`${styles['tab-button-v2']} ${activeTab === 'breads' ? styles['active'] : ''}`}
                onClick={() => onTabChange('breads')}
            >
                Panes
            </button>
        </div>
    );
}
